/**
 * AI Summary Card.
 * Displays AI-generated summary of the dataset analysis.
 */

import React from 'react';
import { ResultCard } from '../common/ResultCard';

interface AISummaryCardProps {
  readonly summary: string;
}

export const AISummaryCard: React.FC<AISummaryCardProps> = ({ summary }) => {
  return (
    <ResultCard
      title="Résumé IA"
      variant="analysis"
    >
      <div style={{ fontSize: '13px', lineHeight: '1.6', color: '#333' }}>
        {summary}
      </div>
    </ResultCard>
  );
};
